import { render, staticRenderFns } from "./OverallComplianceRating.vue?vue&type=template&id=80a923a8"
import script from "./OverallComplianceRating.vue?vue&type=script&lang=js"
export * from "./OverallComplianceRating.vue?vue&type=script&lang=js"
import style0 from "./OverallComplianceRating.vue?vue&type=style&index=0&id=80a923a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports